import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AppInitializerService } from '@app/app-initializer.service';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { MultiTypeUploadModel } from '@app/components/controls/utilities/models/multi-type-upload-model';
import { QuillEditorModel } from '@app/components/controls/utilities/models/quill-editor-model';
import { SkillsSelectionModel } from '@app/components/controls/utilities/models/skills-selection-model';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { PopupComponent } from '@app/components/popup/popup.component';
import { BaseService } from '@app/system/services/base.service';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';
import { ApiService as profileApiService } from '../../people/utilities/services/api.service';
import { ApiService as WorkgroupApiService } from '@app/modules/workgroup/utilities/services/api.service';
import * as pdfjsLib from 'pdfjs-dist';
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min';
import { DetectDeviceService } from '@app/system/services/detect-device.service';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

@Component({
	selector: 'app-bead',
	templateUrl: './bead.component.html',
	styleUrls: ['./bead.component.scss']
})
export class BeadComponent implements OnInit {

	helpTriggered = false;
	loader = false;
	popupRef;
	formFields = [];
	actionType: 'initial' | 'format' | 'page' | 'skillSelection' | 'pageFormat' | 'moderation' = 'initial';
	formObject;
	beadData;
	config = { fxFlex: 100 };
	submitDisable = false;
	formLoader = false;
	currentUser;
	action: 'bead' | 'share' = 'bead';
	keywordFormFields = [];
	skillFormFields = [];
	skillLevelData = [];
	clearTimeout;
	pageData;
	resourceID;
	formObjectData = {
		form: null,
		fields: []
	};
	showDescription = true;
	skillData = [];
	keywordData = [];
	tagUserData = [];
	info = '';
	data;
	title = '';
	deviceDetails;
	skillMPermission = false
	constructor(
		public locale: LocaleService,
		private gfService: GlobalFunctionService,
		private baseService: BaseService,
		private globalApiService: GlobalApiService,
		private appInit: AppInitializerService,
		private apiService: ApiService,
		public detectDevice: DetectDeviceService,
		private profileApiService: profileApiService,
		private popup: MatDialog,
		private workgroupApiService: WorkgroupApiService
	) {
		this.currentUser = this.gfService.sessionUser;
		if (this.currentUser.weightageData) {
			this.skillLevelData = this.currentUser.weightageData.map((data) => {
				return {
					key: data.termID,
					value: data.term,
					weightage: data.index,
					description: data.attributes.description
				};
			});
		}
	}

	ngOnInit() {
		this.deviceDetails = this.detectDevice.fingerPrint;
		this.baseService.formView = true;
		if (this.actionType === 'moderation') {
			this.title = this.locale.translate('moderation');
			this.info = this.locale.translate('this_require_moderation_but_your_not_workgroup_desc');
			const users: AutoCompleteModel = {
				fieldColumn: 'users',
				additionalMetaData: {
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off',
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				validationRegex: null,
				fieldCaption: this.locale.translate('name'),
				fieldHelpText: null,
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('type_name'),
				isMultiple: true,
				options: [],
				selectedValue: [],
				preDefined: true
			};
			this.formFields = [
				users
			];
			if (this.data) {
				this.formObjectData = this.data.formObjectData;
				this.beadData = this.data.beadData;
				this.pageData = this.data.pageData;
			}
		} else {
			const file: MultiTypeUploadModel = {
				fieldCaption: '',
				fieldColumn: 'format',
				validationMessage: this.locale.translate('invalid_file'),
				fieldOrder: 1,
				fieldType: 'multiTypeUpload',
				fieldHelpText: null,
				fieldPlaceholder: this.locale.translate('drop_click_audio_video_document_upload'),
				isRequired: true,
				isHidden: false,
				additionalMetaData: {
					showLabel: false,
					fileSize: '10MB',
					supportedType: ['.pdf', '.mp4', '.mpeg', '.mp3', '.jpg', '.jpeg', '.png'],
					drag: true,
					thumbnailFormat: ['.jpg', '.jpeg', '.png'],
					thumbnailMaxSize: '1MB',
					thumbnailWidth: 150,
					thumbnailHeight: 150
				},
				isReadonly: false,
				value: null
			};
			const title: TextBoxModel = {
				additionalMetaData: {
					maxChar: 250
				},
				fieldColumn: 'title',
				fieldType: 'textBox',
				isHidden: true,
				isReadonly: true,
				isRequired: false,
				type: 'text',
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('title'),
				fieldCaption: this.locale.translate('title')
			};
			const description: TextAreaModel = {
				fieldColumn: 'description',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: true,
				isReadonly: true,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('desc'),
				fieldHelpText: null,
				fieldOrder: 2,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('desc')
			};
			this.formFields = [
				file,
				title,
				description
			];
		}
		if (this.baseService.checkModuleAccess('M13')) {
			this.skillMPermission = true;
		}
	}

	fileDropped(event) {
		if (event && navigator.onLine) {
			const title = this.formFields.find(items => items.fieldColumn === 'title');
			if (title) {
				title.isRequired = true;
				title.isReadonly = false;
				title.isHidden = false;
				this.formObject.form.controls.title.enable();
			}
			this.actionType = 'format';
		}
	}

	addDescription() {
		if (navigator.onLine) {
			const description = this.formFields.find(items => items.fieldColumn === 'description');
			if (description) {
				description.isRequired = false;
				description.isReadonly = false;
				description.isHidden = false;
				this.formObject.form.controls.description.enable();
				this.showDescription = false;
			}
		}
	}

	fileRemoved(event) {
		if (event && navigator.onLine) {
			this.formFields[1].isRequired = false;
			this.formFields[1].isReadonly = true;
			this.formFields[1].isHidden = true;

			this.formFields[2].isRequired = false;
			this.formFields[2].isReadonly = true;
			this.formFields[2].isHidden = true;
			this.actionType = 'initial';
			this.formObject.form.controls.title.patchValue(null);
			this.formObject.form.controls.description.patchValue(null);
			this.beadData = null;
		}
	}

	addPage(update = false) {
		if (navigator.onLine) {
			this.formFields = null;
			this.actionType = 'page';
			// setTimeout(() => {
			const page: QuillEditorModel = {
				fieldCaption: this.locale.translate('page'),
				fieldColumn: 'page',
				validationRegex: '',
				validationMessage: '',
				fieldOrder: 1,
				fieldType: 'quillEditor',
				fieldHelpText: '',
				isRequired: true,
				isHidden: false,
				additionalMetaData: {
					// height: 400,
					showLabel: false,
					imageUploadData: {
						fileSize: '10MB',
						supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
						url: ''
					}
				},
				isReadonly: false,
				value: null,
				fieldPlaceholder: ''
			};
			if (update) {
				page.value = this.pageData;
				this.pageData = null;
			}
			this.showDescription = false;
			this.formFields = [
				page
			];
		}
		// });
	}

	submitPage() {
		if (navigator.onLine) {
			if (this.formObject && this.formObject.form) {
				if (this.formObject.form.valid && this.formObject.form.controls.page.valid) {
					if (this.helpTriggered) {
						this.loader = true;
					} else {
						this.popupRef.componentInstance.popupLoader = true;
					}
					this.formFields = [];
					const formData: any = this.gfService.fieldSubmitApiValueConstruct(
						this.formObject.form.getRawValue(),
						this.formObject.fields
					);
					const title: TextBoxModel = {
						additionalMetaData: {
							maxChar: 250
						},
						fieldColumn: 'title',
						fieldType: 'textBox',
						isHidden: false,
						isReadonly: false,
						isRequired: true,
						type: 'text',
						validationRegex: null,
						fieldPlaceholder: this.locale.translate('title'),
						fieldCaption: this.locale.translate('title')
					};
					const description: TextAreaModel = {
						fieldColumn: 'description',
						additionalMetaData: {
							maxChar: 500,
							showLabel: true
						},
						fieldType: 'textArea',
						isHidden: true,
						isReadonly: true,
						isRequired: false,
						validationRegex: null,
						fieldCaption: this.locale.translate('desc'),
						fieldHelpText: null,
						fieldOrder: 2,
						validationMessage: '',
						fieldPlaceholder: this.locale.translate('desc')
					};
					this.showDescription = true;
					if (this.beadData) {
						title.value = this.beadData.data.title;
						description.value = this.beadData.data.description;
						if (description.value) {
							description.isHidden = false;
							description.isReadonly = false;
							this.showDescription = false;
						}
					}
					this.formFields = [title, description];
					this.pageData = formData.page;
					if (this.helpTriggered) {
						this.loader = false;
					} else {
						this.popupRef.componentInstance.popupLoader = false;
					}
					this.actionType = 'pageFormat';
				} else {
					this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
					this.submitDisable = false;
				}
			}
		}
	}

	updatePage() {
		this.addPage(true);
	}

	formObjectReader(record) {
		this.formObject = record;
		const form: UntypedFormGroup = record.form;
		if (form.controls.users) {
			const usersField = record.fields.find((items) => items.fieldColumn === 'users');
			let subscribe;
			form.controls.users.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							// const userFilter: any = { $and: [] };
							// const splitVal = controlResp.toLowerCase().split(' ');
							// for (const value of splitVal) {
							//   userFilter.$and.push({
							//     $or: {
							//       '$accountDetail.firstName$': { $substring: value },
							//       '$accountDetail.lastName$': { $substring: value }
							//     }
							//   });
							// }
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (usersField.selectedValue.length) {
								usersField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getParentPublisher(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.userID)) {
													return items;
												}
											});
										}
										usersField.options = response.records.map((data) => {
											return {
												key: data.userID,
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										});
									} else {
										usersField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									usersField.options = [];
								}
							);
						} else {
							usersField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

	keywordFormReader(record) {
		this.formObject = record;
		let subscribe;
		const keywords = this.keywordFormFields.find((items) => items.fieldColumn === 'keywords');
		const form: UntypedFormGroup = record.form;
		// if()
		if (form.controls.keywords) {
			form.controls.keywords.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 13
							};
							const header: any = {
								lanCode: sessionStorage.getItem('locale') || 'en'
							};
							let selectedValue = [];
							if (keywords.selectedValue.length) {
								keywords.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										keywords.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										keywords.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									keywords.options = [];
								}
							);
						} else {
							this.keywordData = keywords.selectedValue;
							keywords.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		let skillSubscribe;
		const skills = record.fields.find((items) => items.fieldColumn === 'skillField');
		if (form.controls.skillField) {
			if (skills.fieldType === 'autoComplete') {
				form.controls.skillField.valueChanges.subscribe((controlResp) => {
					if (navigator.onLine) {
						if (skillSubscribe && !skillSubscribe['closed']) {
							skillSubscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp,
									termsetid: 1
								};
								const header: any = {};
								let selectedValue = [];
								if (skills.selectedValue.length) {
									skills.selectedValue.map(items => {
										if (items.isAdd && !items.isDelete) {
											selectedValue.push(items.key);
										}
									});
								}
								skillSubscribe = this.globalApiService.getTerm(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.termID)) {
														return items;
													}
												});
											}
											skills.options = response.records.map((data) => {
												return {
													key: data.termID,
													value: data.term
												};
											});
										} else {
											skills.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										skills.options = [];
									}
								);
							} else {
								this.skillData = skills.selectedValue;
								if (typeof controlResp === 'object') {
									skills.options = [];
								}
							}
						}, this.appInit.configuration.searchDelay);
					}
				});
			} else {
				form.controls.skillField.valueChanges.subscribe(resp => {
					if (resp && resp.length) {
						for (const skill of resp) {
							const selectedSkill = this.skillData.find(items => items.key === skill.key);
							if (!selectedSkill) {
								this.skillData.push(skill);
							} else {
								selectedSkill.skillLevel = skill.skillLevel;
							}
						}
					}
				});

			}
		}

		let tagUserSubscribe;
		const tagUser = record.fields.find((items) => items.fieldColumn === 'taggedUsers');
		if (form.controls.taggedUsers) {
			form.controls.taggedUsers.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (tagUserSubscribe && !tagUserSubscribe['closed']) {
						tagUserSubscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (tagUser.selectedValue.length) {
								tagUser.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							tagUserSubscribe = this.globalApiService.getUsers(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.userID)) {
													return items;
												}
											});
										}
										tagUser.options = response.records.map((data) => {
											return {
												key: data.userID,
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										});
									} else {
										tagUser.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									tagUser.options = [];
								}
							);
						} else {
							this.tagUserData = tagUser.selectedValue;
							if (typeof controlResp === 'object') {
								tagUser.options = [];
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});

		}
	}

	async submitBead() {
		if (navigator.onLine) {
			let formObject = this.formObject;
			if (formObject && formObject.form) {
				this.submitDisable = true;
				if (formObject.form.valid) {
					if (this.helpTriggered) {
						this.loader = true;
					} else {
						this.popupRef.componentInstance.popupLoader = true;
					}
					const formData: any = this.gfService.fieldSubmitApiValueConstruct(
						formObject.form.getRawValue(),
						formObject.fields
					);
					let type = '';
					if (!this.beadData) {
						if (formData.format) {
							if (formData.format.videoFile) {
								formData.format.videoSrc = await this.gfService.fileToDataURL(formData.format.videoFile);
								formData.format.thumbnailSrc = await this.gfService.fileToDataURL(formData.format.thumbnail);
								type = 'video';
							} else if (formData.format.audioFile) {
								formData.format.audioSrc = await this.gfService.fileToDataURL(formData.format.audioFile);
								formData.format.thumbnailSrc = await this.gfService.fileToDataURL(formData.format.thumbnail);
								type = 'audio';
							} else if (formData.format instanceof File) {
								formData.thumbnail = this.baseService.getSnapshot(formData.format.name);
								type = 'document';
							} else if (Array.isArray(formData.format)) {
								const filteredImages = [];
								formData.format.map(async imageValue => {
									if (!imageValue.removed) {
										imageValue.thumbnailSrc = await this.gfService.fileToDataURL(imageValue.file);
										imageValue.cropped = true;
										filteredImages.push(imageValue);
									}
								});
								formData.format = filteredImages;
								type = 'image';
							}
						}
						if (this.actionType === 'pageFormat') {
							type = 'page';
						}
						this.beadData = {
							type,
							data: formData
						};
					} else {
						if (formData.format && formData.format.thumbnail instanceof File) {
							this.beadData.data.format.thumbnailSrc = await this.gfService.fileToDataURL(formData.format.thumbnail);
							this.beadData.data.format.thumbnail = formData.format.thumbnail;
						} else if (formData.format && Array.isArray(formData.format)) {
							const filteredImages = [];
							formData.format.map(async imageValue => {
								if (!imageValue.removed) {
									imageValue.cropped = true;
									imageValue.thumbnailSrc = await this.gfService.fileToDataURL(imageValue.file);
									filteredImages.push(imageValue);
								}
							});
							this.beadData.data.format = filteredImages;
						}
						this.beadData.data.title = formData.title;
						this.beadData.data.description = formData.description;
					}
					this.buildSkill();
					if (this.helpTriggered) {
						this.loader = false;
					} else {
						this.popupRef.componentInstance.popupLoader = false;
					}
					this.submitDisable = false;
				} else {
					this.gfService.fieldControlMarkAsTouched(formObject.fields, formObject.form);
					this.submitDisable = false;
				}
			}

		}
	}

	buildSkill() {
		this.formObjectData = {
			fields: [],
			form: null
		};
		if (this.helpTriggered) {
			this.formLoader = true;
		} else {
			this.popupRef.componentInstance.popupLoader = true;
		}
		const keywords: AutoCompleteModel = {
			fieldColumn: 'keywords',
			fieldCaption: this.locale.translate('keywords_resource'),
			additionalMetaData: {},
			fieldType: 'autoComplete',
			isHidden: false,
			isReadonly: false,
			isRequired: true,
			validationRegex: null,
			value: null,
			fieldPlaceholder: this.locale.translate('keywords_resource'),
			selectedValue: [],
			type: 'general',
			isMultiple: true,
			options: [],
			fieldHelpText: '',
			preDefined: true
		};
		let skills: SkillsSelectionModel | AutoCompleteModel;
		skills = {
			fieldCaption: this.locale.translate('skills'),
			fieldColumn: 'skillField',
			validationMessage: null,
			fieldOrder: 1,
			fieldType: 'skillsSelectionField',
			fieldHelpText: null,
			fieldPlaceholder: this.locale.translate('skills'),
			isRequired: true,
			isHidden: false,
			options: null,
			additionalMetaData: {
				maxWeightage: this.skillLevelData,
				minWeightage: 0,
				defaultWeightage: 0,
				showHelp: true,
				showLabel: false
			},
			isReadonly: false,
			value: null
		};
		if (this.keywordData) {
			keywords.selectedValue = this.keywordData;
			keywords.value = this.keywordData;
		}
		const headers: any = {};
		this.profileApiService.userCompetency(this.currentUser.userID, headers).subscribe(
			(response) => {
				if (response && response.competencies && response.competencies.length) {
					if (this.skillData) {
						skills.value = this.skillData;
					}
					skills.options = this.dataBuild(response.competencies);
				} else {
					skills = {
						fieldColumn: 'skillField',
						additionalMetaData: {
							showLabel: true,
							autoFill: 'off',
							defaultWeightage: 1,
							minWeightage: 1,
							showHelp: true
						},
						fieldType: 'autoComplete',
						isHidden: false,
						isMultiple: true,
						isReadonly: false,
						isRequired: true,
						options: [],
						selectedValue: [],
						fieldCaption: this.locale.translate('search_skills'),
						fieldOrder: 3,
						preDefined: false,
						fieldPlaceholder: this.locale.translate('search_skills'),
						type: 'weightage'
					};
					if (this.currentUser.weightageData) {
						skills.additionalMetaData.maxWeightage = this.currentUser.weightageData.map((data) => {
							return {
								key: data.termID,
								value: data.term,
								weightage: data.index,
								description: data.attributes.description
							};
						});
					}
					if (this.skillData) {
						skills.value = this.skillData;
						skills.selectedValue = this.skillData;
					}
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				const headers: any = {};
				this.workgroupApiService.getJoinedWGList(headers).subscribe(
					(workgroupResponse) => {
						if (workgroupResponse && workgroupResponse.records && workgroupResponse.records.length) {
							if(this.baseService.checkModuleAccess('M13')){
								this.skillFormFields = [skills];
							}
						} else {
							const tagUser: AutoCompleteModel = {
								fieldColumn: 'taggedUsers',
								additionalMetaData: {
									showLabel: true,
									autoFill: 'off'
								},
								fieldType: 'autoComplete',
								isHidden: false,
								isMultiple: true,
								isReadonly: false,
								isRequired: true,
								options: [],
								selectedValue: [],
								fieldCaption: this.locale.translate('tag_your_managers_supervisors'),
								fieldOrder: 3,
								preDefined: true,
								fieldPlaceholder: this.locale.translate('search_users'),
								type: 'general'
							};
							if (this.tagUserData) {
								tagUser.selectedValue = this.tagUserData;
								tagUser.value = this.tagUserData;
							}
							if(this.baseService.checkModuleAccess('M13')){
								this.skillFormFields = [skills, tagUser];
							} else{
								this.skillFormFields = [tagUser];
							}
							
						}
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				)
					.add(() => {
						this.keywordFormFields = [keywords];
						if (this.helpTriggered) {
							this.formLoader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
						this.submitDisable = false;
						this.actionType = 'skillSelection';
					});
			});
	}

	dataBuild(records: any) {
		let data = [];
		let skillData;
		for (const competency of records) {
			competency.childData = {
				caption: null,
				data: []
			};
			for (const skill of competency.skills) {
				const pushJson = {
					key: skill.ID,
					value: skill.name,
					skillLevel: skill.skillLevel
				};
				// if (this.skillData && this.skillData.length) {
				// 	const selectionSKill = this.skillData.find(items => items.key === skill.ID);
				// 	if (selectionSKill) {
				// 		pushJson.skillLevel = selectionSKill.skillLevel;
				// 	}
				// }
				competency.childData.data.push(pushJson);
			}
			data.push({
				key: competency.ID,
				value: competency.name,
				childData: competency.childData,
				selected: false
			});
		}
		if (data.length > 0) {
			skillData = {
				caption: this.locale.translate('select_competency'),
				data
			};
		}
		return skillData;
	}

	loadMySkills(skills) {
		const apiData = {};
		const headers: any = {};
		skills.options = [];
		this.globalApiService.getMySkills(apiData, headers).subscribe(
			(response) => {
				if (response && Array.isArray(response.records)) {
					skills.options = response.records.map(resp => {
						return {
							key: resp.skill,
							value: resp.skillName
						};
					});
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
			});
	}

	navigateToBack() {
		if (navigator.onLine) {
			const title = this.formFields.find(items => items.fieldColumn === 'title');
			if (title) {
				title.value = this.beadData.data.title;
			}
			const description = this.formFields.find(items => items.fieldColumn === 'description');
			if (description) {
				description.value = this.beadData.data.description;
			}
			const format = this.formFields.find(items => items.fieldColumn === 'format');
			if (this.beadData.type === 'audio') {
				format.value = {
					file: this.beadData.data.format.audioFile,
					thumbnail: this.beadData.data.format.thumbnailSrc
				};
			} else if (this.beadData.type === 'video') {
				format.value = {
					file: this.beadData.data.format.videoFile,
					thumbnail: this.beadData.data.format.thumbnailSrc
				};
			} else if (this.beadData.type === 'document') {
				format.value = {
					file: this.beadData.data.format
				};
			} else if (this.beadData.type === 'image') {
				format.value = this.beadData.data.format;
			}
			if (this.beadData && this.beadData.type === 'page') {
				this.actionType = 'pageFormat';
			} else {
				this.actionType = 'format';
			}
		}
	}

	checkBead() {
		if (navigator.onLine) {
			if (this.formObjectData && this.formObjectData.form) {
				this.submitDisable = true;
				if (this.formObjectData.form.valid) {
					if (this.helpTriggered) {
						this.loader = true;
					} else {
						this.popupRef.componentInstance.popupLoader = true;
					}
					if (this.action === 'share') {
						this.addBead();
					} else {
						this.addBead();
					}
				} else {
					this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
					this.submitDisable = false;
				}
			}
		}
	}

	moderation() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: BeadComponent,
				componentData: [
					{
						variableName: 'tabIndex',
						value: 0
					},
					{
						variableName: 'action',
						value: this.action
					},
					{
						variableName: 'actionType',
						value: 'moderation'
					},
					{
						variableName: 'data',
						value: {
							formObjectData: this.formObjectData,
							beadData: this.beadData,
							pageData: this.pageData
						}
					},
					{
						variableName: 'resourceID',
						value: this.resourceID
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		this.popupRef.close({ dialogRef });
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	moderationSubmit() {
		if (navigator.onLine) {
			if (this.formObject && this.formObject.form) {
				this.submitDisable = true;
				this.gfService.alertClear('knowledgeCardBead');
				if (this.formObject.form.valid) {
					if (this.helpTriggered) {
						this.loader = true;
					} else {
						this.popupRef.componentInstance.popupLoader = true;
					}
					let formData: any = this.gfService.fieldSubmitApiValueConstruct(
						this.formObject.form.getRawValue(),
						this.formObject.fields
					);
					let users = [];
					for (const data of formData.users) {
						if (data.isAdd && !data.isDelete) {
							users.push(data.key);
						}
					}
					this.addBead(users);
				} else {
					this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
					this.submitDisable = false;
				}
			}
		}
	}

	async addBead(users = []) {
		if (navigator.onLine) {
			const formData: any = this.gfService.fieldSubmitApiValueConstruct(
				this.formObjectData.form.getRawValue(),
				this.formObjectData.fields
			);
			const keywords = [];
			if (formData && formData.keywords) {
				for (const keyword of formData.keywords) {
					if (keyword.hasOwnProperty('value')) {
						if (keyword.value.isAdd && !keyword.value.isDelete) {
							keywords.push(keyword.value.value);
						}
					} else {
						if (keyword.isAdd && !keyword.isDelete) {
							keywords.push(keyword.key);
						}
					}

				}
			}
			formData.keywords = keywords;

			const skills = [];
			if (formData && formData.skillField) {
				for (const skill of formData.skillField) {
					if (skill.hasOwnProperty('key')) {
						if (!skill.isDelete) {
							skills.push({
								skillLevel: skill.skillLevel || skill.progress,
								skill: skill.key
							});
						}
					} else if (skill.value) {
						if (skill.value.isAdd && !skill.value.isDelete) {
							skills.push({
								skillName: skill.value.value,
								skillLevel: skill.value.progress
							});
						}
					}
				}
			}

			const taggedUsers = [];
			if (formData && formData.taggedUsers) {
				for (const user of formData.taggedUsers) {
					if (user.isAdd && !user.isDelete) {
						taggedUsers.push(user.key);
					}
				}
			}
			formData.taggedUsers = taggedUsers;

			let apiData: any = {
				languageCode: 'en',
				title: this.beadData.data.title,
				description: this.beadData.data.description,
				keywords: formData.keywords,
				authors: [{
					id: this.currentUser.userID
				}],
				infoFields: {},
				taggedUsers: formData.taggedUsers
			};

			if (skills.length > 0) {
				apiData.skills = skills;
			}
			if (this.action === 'bead') {

				const resourceStatus = this.baseService.resourceStatus;
				for (const status of resourceStatus) {
					if (status.key === 'draft') {
						apiData.status = status.value;
					}
				}
			}
			let resourceFormat;
			if (this.action === 'bead' || this.action === 'share') {
				if (this.resourceID) {
					apiData.infoFields.resRef = this.resourceID;
				}
				if (this.beadData.type === 'embed') {
					apiData.infoFields.updateProfile = (formData.updateProfile[0] !== null) ? formData.updateProfile[0] : false;
				}
			}
			if (this.beadData.type === 'document') {
				apiData.resourceFormat = 1;
				apiData.file = this.beadData.data.format;
				const totalWordCount: any = await this.readPdfFile(this.beadData.data.format);
				apiData.resource = {
					duration: this.gfService.getEstimatedReadingTime(totalWordCount, 'hh:mm')
				};
				// apiData.thumbnail = this.beadData.data.document;
			} else if (this.beadData.type === 'video') {
				apiData.file = this.beadData.data.format.videoFile;
				apiData.thumbnail = this.beadData.data.format.thumbnail;
				apiData.resourceFormat = 2;
				apiData.resource = {
					duration: this.beadData.data.format.duration
				};
			} else if (this.beadData.type === 'audio') {
				apiData.file = this.beadData.data.format.audioFile;
				apiData.thumbnail = this.beadData.data.format.thumbnail;
				apiData.resourceFormat = 3;
				apiData.resource = {
					duration: this.beadData.data.format.duration
				};
			} else if (this.beadData.type === 'embed') {
				apiData.resource = {
					link: this.beadData.data.embed.link,
					thumbnail: this.beadData.data.embed.image
				};
				apiData.resourceFormat = 5;
				if (formData.evidenceFile) {
					apiData.evidenceFile = formData.evidenceFile;
				}
				apiData.title = this.beadData.data.embed.title;
				apiData.description = this.beadData.data.embed.description;
			} else if (this.beadData.type === 'page') {
				function extractContent(htmlString) {
					let span = document.createElement('span');
					span.innerHTML = htmlString;
					return span.innerText.split(' ').length;
				};
				let wordsLength = extractContent(this.pageData);
				apiData.resourceFormat = 4;
				apiData.resource = {
					innerHtml: this.pageData,
					duration: this.gfService.getEstimatedReadingTime(wordsLength, 'hh:mm')
				};
			} else if (this.beadData.type === 'image') {
				apiData.resourceFormat = 6;
				const caption = [];
				this.beadData.data.format.map((imageValue, index) => {
					if (!imageValue.removed) {
						let pushData = imageValue.caption;
						if (!pushData) {
							pushData = '';
						}
						caption.push(pushData);
					}
				});
				if (caption.length > 0) {
					apiData.caption = caption;
				}
			}
			if (apiData.infoFields && !Object.keys(apiData.infoFields).length) {
				delete apiData.infoFields;
			}
			resourceFormat = apiData.resourceFormat;
			if (users && users.length) {
				apiData.submittedTo = users[0];
			}
			apiData.notificationType = 1;
			if (this.deviceDetails.browserName === 'Safari') {
				apiData.notificationType = 2;
			}
			apiData = this.gfService.convertToFormData(apiData);
			if (this.beadData.type === 'image' && this.beadData && this.beadData.data && Array.isArray(this.beadData.data.format) && this.beadData.data.format.length) {
				this.beadData.data.format.map(async (resp) => {
					if (!resp.removed) {
						apiData.append('image', resp.file);
					}
				});
			}
			const headers: any = {};
			this.apiService.addBead(apiData, headers).subscribe(
				(response) => {
					const userActivityData = {
						resourceID: (response && response.recordID) ? response.recordID.resourceID : null,
						authors: [
							{
								userID: this.currentUser.userID
							}
						]
					};
					this.baseService.logUserActivity('createknowledgebead', 'sharing', [''], { resourceData: userActivityData });
					this.beadData.resourceID = response.recordID;
					this.beadData.resourceFormat = resourceFormat;
					this.popupRef.close(this.beadData);
					this.gfService.openSnackBar('SUCCESS', {
						message: this.locale.translate('bead_submitted'),
						icon: 'check_circle_outline',
						position: 'before'
					});
				},
				(error) => {
					// if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'NOT_IN_WORKGROUP') {
					// 	this.moderation();
					// }
					this.gfService.errorHandler(error, {
						alert: {
							id: 'knowledgeCardBead'
						},
						form: this.formObject.form
					});
				}
			).add(() => {
				if (this.helpTriggered) {
					this.loader = false;
				} else {
					this.popupRef.componentInstance.popupLoader = false;
				}
				this.submitDisable = false;
			});
		}
		// } else {
		// 	this.moderation();
		// }
	}

	async readPdfFile(file) {
		return new Promise(async (resolve, reject) => {
			const fileDataURL: any = await this.gfService.fileToDataURL(file);
			pdfjsLib.getDocument({ data: atob(fileDataURL.substring("data:application/pdf;base64,".length)) })
				.promise
				.then(async (PDFDocumentInstance) => {
					let totalWordCount = 0;
					for (let i = 1; i <= PDFDocumentInstance.numPages; i++) {
						let wordCount = await this.getPageText(i, PDFDocumentInstance);
						// console.log(wordCount);
						totalWordCount += wordCount;
					}
					return totalWordCount;
				}).then((wordCount) => {
					console.log(wordCount);
					resolve(wordCount);
				});
		});
	}

	async getPageText(pageNum, PDFDocumentInstance): Promise<any> {
		return new Promise(async (resolve, reject) => {
			PDFDocumentInstance.getPage(pageNum).then((pdfPage) => {
				pdfPage.getTextContent().then((textContent) => {
					// console.log(textContent, pageNum)
					let textItems = textContent.items;
					// console.log(textItems)
					let wordCount = 0;
					for (let i = 0; i < textItems.length; i++) {
						let item = textItems[i];
						if (item.str.match(/\w+|\d+/g)) {
							// console.log(item.str.match(/\w+|\d+/g).length, item.str);
							wordCount += item.str.match(/\w+|\d+/g).length;
						}
					}
					// if (pageNum === PDFDocumentInstance.numPages) {
					// 	console.log(pageNum, this.wordsCount, wordCount);
					// }
					return wordCount;
				}).then((wordCount) => {
					resolve(wordCount);
				});
			});
		});
	}

	alertPopup(event = null) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title: this.locale.translate('abort_process'),
				content: this.locale.translate('abort_process_text'),
				buttons: [
					{
						type: 'main-action',
						caption: this.locale.translate('yes'),
						key: 'yes'
					},
					{
						type: 'main-action',
						caption: this.locale.translate('no'),
						key: 'no',
						autoFocus: true
					}
				],
				triggerEl: event
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					this.popupRef.close('closed');
				}
			}
		});
	}

	dialogClose() {
		if (this.keywordFormFields.length || (this.formObject.form && this.formObject.form.controls && ((this.formObject.form.controls.title && this.formObject.form.controls.title.enabled) || (this.formObject.form.controls.page && this.formObject.form.controls.page.enabled)))) {
			this.alertPopup();
		} else {
			this.popupRef.close('closed');
		}
	}
}
